import { CreateWidgetsMap } from "../types/WidgetModule";
import { defineCustomElement } from "./defineCustomElement";

const isMatchingTag = (root: ParentNode, tag: string): boolean => {
  const isRootTag = root instanceof Element && typeof root.matches === 'function' && root.matches(tag);
  return isRootTag || Boolean(root.querySelector(tag));
};

export async function loadClientWidgets<
  T extends Record<string, () => Promise<any>>,
>(widgets: CreateWidgetsMap<T>, root: ParentNode = document) {
  await Promise.all(
    Object.entries(widgets).map(async ([tag, module]) => {
      if (customElements.get(tag) || !isMatchingTag(root, tag)) {
        return;
      }

      try {
        const widget = await module();
        if (!widget.disableClientRender) {
          defineCustomElement({
            tag,
            Component: widget.default,
          });
        }
      } catch (error) {
        console.error(error);
      }
    })
  );
}
